import styled from 'styled-components'
export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  z-index: 12;
  display: ${(props) => (props.on ? 'block' : 'none')};
  #reader {
    overflow: hidden;
    width: 100vw;
  }
`
export const Actions = styled.div`
  position: absolute;
  top: 20px;

  left: 20px;
  z-index: 99;

  button {
    border-radius: 360px;
    border: none;
    background: rgba(255, 255, 255, 0.2);

    padding: 8px;
    margin-right: 12px;

    svg {
      color: rgba(255, 255, 255, 0.5);
      font-size: 27px;
      display: flex;
    }
  }
`
